import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AllowanceType,
  CorpTypeList2,
  FacilityKbn,
  formClassFacility,
  FormKbn,
  Prefectures,
  UseOrNot,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStrpper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkSalaryAdjustmentAmount from "../../components/molecules/TkSalaryAdjustmentAmount";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_FAC004_Response,
  IAPI_FAC022_Response,
  IAPI_FAC029_Request,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import { createSelList } from "../../utils/useTools";
import {
  httpIAPI_FAC004,
  httpIAPI_FAC022,
  httpIAPI_FAC029,
} from "./api/request";
import {
  fakeTableList,
  dynamicSchema,
  schema,
  showNumberOfDisabledChildSaff,
  showNumberOfSpecificEmployees,
  stepperData,
} from "./parts";
import _ from "lodash";
import { bussinessType } from "../../assets/data/TkBussinessTypeProperty";
import { CheckedList } from "../../type/apiType/IAPI_FAC029";
import { Facility } from "../../type/componentsType/TkFacilityselection";
import { TkRouteContext } from "../../context/tkRouteContext";
import { toNumberOrUndefined } from "../../utils/useTools";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC050101施設情報　新規登録
 * このコンポーネントは、TkInfoManualとTkFakeTableをレンダリングします。
 * @returns JSX.Element
 */
const SCRC050101 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [stateSchema, setStateSchema] = useState({
    ...schema,
    ...dynamicSchema,
  });

  const [resInit, setResInit] = useState<IAPI_FAC004_Response>();
  const [resTransf, setResTransf] = useState<IAPI_FAC022_Response>();
  const [currentFacility, setCurrentFacility] = useState<Facility>();
  const [currentTransferCode, setCurrentTransferCode] = useState<
    string | undefined
  >();
  const [selectedAllowanceList, setSelectedAllowanceList] = useState<any[]>([]);
  const [dispApplyDate, setDispApplyDate] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [openWarning, setOpenWarning] = useState(false);
  const reqDataRef = useRef<any>();
  const buttonIndexRef = useRef<any>();

  // 雇用契約上の雇用期間1年未満職員数
  const [yearJoindisableStaffNumRef, setYearJoindisableStaffNumNumRef] =
    useState(0);
  // 雇用契約上の労働時間２
  const [timeJoindisableStaffNumRef, setTimeJoindisableStaffNumRef] =
    useState(0);

  // 申込時職員総数
  const totalStaffNumRef = useRef<number>(0);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo!
    : state.authInfo?.contractorNo!;
  const businessType = businessState.common?.businessType;
  const isJob_15 = businessType === bussinessType.JOB["JOB-15"];
  const jobName = isJob_15 ? "job_15" : "job_01";
  const job_xx = businessState[jobName];
  const applyId = location.state?.applyId ?? job_xx?.applyId;
  // チェック済みリスト
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);
  const corpTypeSchool: (string | undefined)[] = [
    CorpTypeList2["学校法人"],
    CorpTypeList2["学校法人（認定こども園）"],
  ];
  const notAllowe =
    corpTypeSchool.includes(state.authInfo?.businessOwnerClass!) &&
    new Date(state.authInfo?.contractDate!) >= new Date("2015/04/01");

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );
  const [specificStaffNumCanInputFlg, setSpecificStaffNumCanInputFlg] =
    useState<string>("0");

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 加入職員数の計算と表示
  useEffect(() => {
    const joinStaffNum = resInit?.joinStaffNum ?? 0;
    let resArr = stateFakeTableList.current;
    const totalStaffNum = resArr.find(
      (item) => item.keyword === "totalStaffNum"
    )!;

    const calculatedTotalStaffNum =
      +yearJoindisableStaffNumRef + +joinStaffNum + +timeJoindisableStaffNumRef;
    totalStaffNum.text = `${
      !calculatedTotalStaffNum ? 0 : calculatedTotalStaffNum
    }人`;

    totalStaffNumRef.current = !calculatedTotalStaffNum
      ? 0
      : calculatedTotalStaffNum;

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    yearJoindisableStaffNumRef,
    timeJoindisableStaffNumRef,
    resInit?.joinStaffNum,
  ]);

  const handleConfirm = (selectedList: any, applyAllowanceNameList: any) => {
    const selectedApplyAllowanceList = applyAllowanceNameList
      .filter((s: any) =>
        selectedList?.find((ss: any) => ss.label === s.applyAllowanceName)
          ? true
          : false
      )
      .map((s: any) => {
        return {
          allowanceSerialNo: s.allowanceSerialNo,
        };
      });
    setSelectedAllowanceList(selectedApplyAllowanceList || []);
    let resArr = stateFakeTableList.current;
    let salaryAdjustmentAmount = resArr.find(
      (item) => item.keyword === "salaryAdjustmentAmount"
    )!;
    let selList = applyAllowanceNameList
      ? createSelList(AllowanceType, applyAllowanceNameList)
      : [];
    salaryAdjustmentAmount.node = (
      <TkSalaryAdjustmentAmount
        open={false}
        onConfirm={(e: any) => handleConfirm(e, applyAllowanceNameList)}
        selList={selList}
        selectedList={selectedList}
        title="この施設で使用する手当を選択してください。"
      />
    );

    setStateTableList([...resArr]);
  };

  const handleCallApiInit = async () => {
    // 施設情報　新規登録（通常）表示
    try {
      const res = await httpIAPI_FAC004({
        contractorNo: contractorNo,
        applyId: applyId,
        facilityNo: job_xx?.facilityNo,
        businessType,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;
        setSpecificStaffNumCanInputFlg(res.specificStaffNumCanInputFlg ?? "0");

        // 持回情報.施設番号=null かつ、1.(2).申請id≠null  かつ　JOB-15　の場合、SCRC050103へ遷移する。
        if (
          isJob_15 &&
          !job_xx?.facilityNo &&
          res.applyId !== null &&
          !job_xx?.signUpFlg
        ) {
          setBusinessState({
            ...businessState,
            [jobName]: {
              ...job_xx,
              applyId: res.applyId,
            },
          });
          navigate("/SCRC050103", {
            state: {
              deleteFlg: true,
              wantToSetInRouterList: wantToSetInRouterList.current,
            },
          });
          return;
        }

        // 新設・申出年月日
        setDispApplyDate(!!res.transferCd);

        //　申請IDがない場合、持回り情報に申請IDを設定する。
        if (!applyId) {
          setBusinessState({
            ...businessState,
            [jobName]: {
              ...job_xx,
              applyId: res.applyId,
            },
          });
        }

        //認証情報.経営者種別＝「学校法人」　かつ　認証情報.契約年月日≧20150401　かつ　JOB-15　の場合,新規登録できないことを画面に表示し、機構への問い合わせを促す。（メッセージID：TKMSG_SCR0001I）
        if (notAllowe && isJob_15 && !res.transferCd) {
          resArr.forEach((item) => (item.disabled = true));
          setShowButton(false);
          setState({
            ...state,
            errorMsgId: "TKMSG_SCR0001I",
          });
          return;
        }

        // 初期表示
        handleScreenRendering(res);

        let applyDate = resArr.find((item) => item.keyword === "applyDate")!;
        let title4 = resArr.find((item) => item.keyword === "title4")!;
        let transferCode = resArr.find(
          (item) => item.keyword === "transferCode"
        )!;

        let salaryAdjustmentAmount = resArr.find(
          (item) => item.keyword === "salaryAdjustmentAmount"
        )!;
        const yearJoindisableStaffNum = resArr.find(
          (item) => item.keyword === "yearJoindisableStaffNum"
        )!;
        const timeJoindisableStaffNum = resArr.find(
          (item) => item.keyword === "timeJoindisableStaffNum"
        )!;

        yearJoindisableStaffNum.onGetInputValue = (value: any) => {
          setYearJoindisableStaffNumNumRef(value?.target?.value ?? 0);
        };

        timeJoindisableStaffNum.onGetInputValue = (value: any) => {
          setTimeJoindisableStaffNumRef(value?.target?.value ?? 0);
        };

        applyDate.onGetInputValue = (e: any) => {
          applyDate.setDefaultValue = e.target.value;
        };

        const facilityName = resArr.find(
          (item) => item.keyword === "facilityName"
        )!;

        facilityName.onGetInputValue = (e: any) => {
          facilityName.setDefaultValue = e.target?.value;
        };

        // 新規契約（JOB-01）の場合
        if (
          businessState.common?.businessType === bussinessType.JOB["JOB-01"]
        ) {
          applyDate.disabled = true;
          applyDate.setDefaultValue = businessState.job_01?.desiredContractDate;
          title4.showLine = false;
          salaryAdjustmentAmount.showLine = false;
          if (
            // 持回情報.経営者種別＝「学校法人」の場合、引継ぎコードの利用は必須のため「利用する」を初期値ONにして、「利用しない」入出力項目.引継ぎコードを非活性にする。
            corpTypeSchool.includes(businessState.job_01?.businessOwnerClass)
          ) {
            transferCode.isSchool = true;
          }
        }

        //引継ぎコード
        transferCode.setDefaultValue = res.transferCd;
        transferCode.disabled = !!res.transferCd;
        setCurrentTransferCode(res.transferCd);

        //「俸給の調整額」対象手当
        let selList = res?.applyAllowanceNameList
          ? createSelList(AllowanceType, res.applyAllowanceNameList)
          : [];
        let selectedApplyAllowanceList = res.applyAllowanceNameList?.filter(
          (s: any) =>
            !!res.selectedApplyAllowanceList?.find(
              (ss) => ss.allowanceSerialNo === s.allowanceSerialNo
            )
        );

        let selectedList = selectedApplyAllowanceList
          ? createSelList(AllowanceType, selectedApplyAllowanceList)
          : [];

        setSelectedAllowanceList(
          selectedApplyAllowanceList?.map((s: any) => {
            return {
              allowanceSerialNo: s.allowanceSerialNo,
            };
          }) || []
        );
        salaryAdjustmentAmount.node = (
          <TkSalaryAdjustmentAmount
            open={false}
            onConfirm={(e: any) =>
              handleConfirm(e, res?.applyAllowanceNameList ?? [])
            }
            selList={selList}
            selectedList={selectedList}
            title="この施設で使用する手当を選択してください。"
          />
        );

        //申込時職員総数
        resArr.find((item) => item.keyword === "totalStaffNum")!.text = `${
          res.totalStaffNum ?? 0
        }人`;

        //加入職員数
        resArr.find((item) => item.keyword === "joinStaffNum")!.text = `${
          res.joinStaffNum ?? 0
        }人`;

        // 当該施設・事業を経営している証拠書類
        let documentaryEvidence = resArr.find(
          (item) => item.keyword === "documentaryEvidence"
        )!;
        let targetFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["施設書類"] &&
            item.formClass ===
              formClassFacility["当該施設・事業を経営している証拠書類"] &&
            item.facilityNo === job_xx?.facilityNo
        );
        if (targetFile) {
          documentaryEvidence.setDefaultValue = [
            {
              formName: targetFile.fileName,
              fileBase64: targetFile.fileBase64,
            },
          ];
        }

        // 単位掛金額
        let facilityKbn = resArr.find(
          (item) => item.keyword === "facilityKbn"
        )!;
        facilityKbn.explan = facilityKbn.explan?.replace(
          "{$1}",
          `${res.unitPremiumAmt! * 3}`
        );

        setResInit(res);
        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 画面描画
  const handleScreenRendering = (res: IAPI_FAC004_Response) => {
    let resArr = stateFakeTableList.current;

    (Object.keys(res) as (keyof typeof res)[]).forEach((i) => {
      const j = i;
      let targetObj = resArr.find((item: any) => item.keyword === j);
      if (targetObj) {
        if (i === "yearJoindisableStaffNum") {
          setYearJoindisableStaffNumNumRef(res[i] ?? 0);
          targetObj.setDefaultValue = res[i];
          targetObj.text = res[i];
          return;
        } else if (i === "timeJoindisableStaffNum") {
          setTimeJoindisableStaffNumRef(res[i] ?? 0);
          targetObj.setDefaultValue = res[i];
          targetObj.text = res[i];
          return;
        } else if (i === "joinStaffNum") {
          targetObj.text = `${res[i] ?? "0"}人`;
          return;
        }

        targetObj.setDefaultValue = res[i];
        targetObj.text = res[i];
      }
    });

    // 契約者（法人）名
    let contractorName = resArr.find(
      (item: any) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isKiko;
    contractorName.contractorNumber = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;

    //施設種類
    let facilityKind = resArr.find(
      (item: any) => item.keyword === "facilityKind"
    )!;
    facilityKind.isResisterApplyFlg =
      res?.businessOwnerClass !== CorpTypeList2["社会福祉法人"];

    //施設区分
    resArr.find((item: any) => item.keyword === "facilityKbn")!.text =
      TkGetCode(FacilityKbn, res.facilityKbn);

    //住所
    resArr.find((item: any) => item.keyword === "address")!.valueObject = {
      prefectures: TkGetCode(Prefectures, res.prefectureCd!),
      city: res.city!,
      address: res.addressOthers!,
    };

    // 入所定員
    resArr.find(
      (item: any) => item.keyword === "admissionCapacityNum"
    )!.onGetInputValue = (e: any) => {
      resArr.find(
        (item: any) => item.keyword === "admissionCapacityNum"
      )!.setDefaultValue = e.target.value;

      _.debounce((resArr) => {
        setStateTableList([...resArr]);
      }, 1000);
    };

    // 職員基準数
    resArr.find(
      (item: any) => item.keyword === "staffBaseNum"
    )!.onGetInputValue = (e: any) => {
      resArr.find(
        (item: any) => item.keyword === "staffBaseNum"
      )!.setDefaultValue = e.target.value;

      _.debounce((resArr) => {
        setStateTableList([...resArr]);
      }, 1000);
    };

    setResInit({
      ...resInit,
      joinStaffNum: res.joinStaffNum,
    });
    setStateTableList([...resArr]);
    setCurrentFacility({
      id: 0,
      name: "",
      category: "",
      partitioncodename: res.facilityKbnName ?? "",
      partitioncode: res.facilityKbn ?? "",
      typecode: res.facilityKind ?? "",
    });
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let transferCode = resArr.find((item) => item.keyword === "transferCode")!;
    let facilityKind = resArr.find(
      (item: any) => item.keyword === "facilityKind"
    )!;
    let zipcode = resArr.find((item: any) => item.keyword === "zipcode")!;
    // 引継ぎコード
    transferCode.getTransferCode = async (value: any) => {
      // 施設引き継ぎコード参照API呼び出し
      try {
        const res = await httpIAPI_FAC022({
          transferCd: value,
        });

        if (res.resultCd === "I0000") {
          // 画面再描画
          handleScreenRendering(res);
          setResTransf(res);
          setDispApplyDate(true);
          setCurrentTransferCode(value);
          resArr.find((item) => item.keyword === "transferCode")!.disabled =
            true;
          if (notAllowe && isJob_15) {
            resArr.forEach((item) => {
              item.keyword !== "applyDate" && (item.disabled = false);
            });
            setShowButton(true);
          }
          setState({ ...state, errorMsgId: "" });
        } else {
          if (notAllowe && isJob_15) {
            resArr.forEach((item) => (item.disabled = true));
            setShowButton(false);
          }
          setCurrentTransferCode(undefined);
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        navigate("/error");
      }
    };

    transferCode.onGetValue = (value: any) => {
      if (value === UseOrNot["利用しない"]) {
        setDispApplyDate(false);
        setCurrentTransferCode(undefined);
      } else {
        setDispApplyDate(true);
      }
    };

    // 施設種類
    facilityKind.getFacilityList = (value: Facility) => {
      setCurrentFacility(value);
      const facilityKind = resArr.find(
        (item: any) => item.keyword === "facilityKind"
      )!;

      facilityKind.setDefaultValue = value.typecode;
      setStateTableList([...resArr]);
    };

    // 住所検索
    zipcode.getPostalCodeValue = (value: any) => {
      if (!value) return;
      const data = value.value;

      let resObj = {
        prefectures: data.address1,
        city: `${data.address2}${data.address3}`,
        address: "",
      };

      resArr.find((item) => item.keyword === "address")!.valueObject = resObj;

      setState({
        ...state,
        errorMsgId: "",
      });
    };

    zipcode.onGetValue = (value: any) => {
      const zipcode = resArr.find((item) => item.keyword === "zipcode")!;
      zipcode.setDefaultValue = value;

      setStateTableList([...resArr]);
    };

    zipcode.getPostalCodeError = (value: any) => {
      setState({
        ...state,
        errorMsgId: value,
      });
    };

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // 新設・申出年月日の活性/非活性
  useEffect(() => {
    if (businessState.common?.businessType === bussinessType.JOB["JOB-01"])
      return;

    let resArr = stateFakeTableList.current;

    resArr.find((item) => item.keyword === "applyDate")!.disabled =
      dispApplyDate;

    setStateTableList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispApplyDate]);

  // 施設種類の選択による仕様処理
  useEffect(() => {
    let _stateTableList = stateFakeTableList.current;
    // 選択した施設が「特定介護保険施設等」又は「申出施設等」かどうか
    const careFlag =
      currentFacility?.partitioncode === FacilityKbn["特定介護保険施設等"];
    const offerFlag =
      currentFacility?.partitioncode === FacilityKbn["申出施設等"];
    const flag = offerFlag || careFlag;
    //「施設区分」を設定
    let facilityKbn = _stateTableList.find(
      (item) => item.keyword === "facilityKbn"
    )!;
    facilityKbn.text = currentFacility?.partitioncodename;
    //「施設区分」の赤文字を設定
    facilityKbn.isShowexplan = flag;
    // 説明文の表示切替
    _stateTableList.find((item: any) => item.keyword === "title6")!.showLine =
      flag;
    //「給与支払遅延の有無」の必須マーク
    let salaryPaymentDelayFlg = _stateTableList.find(
      (item) => item.keyword === "salaryPaymentDelayFlg"
    )!;
    salaryPaymentDelayFlg.requiredIcon = flag;
    // 「給与支払遅延の有無」の表示切替
    salaryPaymentDelayFlg.showLine = flag;
    //「当該施設等が共済契約を締結していたことの有無」の活性と値
    let hadContractFlg = _stateTableList.find(
      (item) => item.keyword === "hadContractFlg"
    )!;
    hadContractFlg.disabled = !flag || !!currentTransferCode;
    if (!flag) hadContractFlg.setDefaultValue = undefined;
    //「当該施設等が共済契約を締結していたことの有無」の表示
    hadContractFlg.showLine = flag;
    //引継ぎコードが設定されている場合の「当該施設等が共済契約を締結していたことの有無」の値設定
    if (currentTransferCode) {
      hadContractFlg.setDefaultValue = resTransf?.hadContractFlg;
    }
    //「解除年月日」の活性と値
    let pastContractCancelDate = _stateTableList.find(
      (item) => item.keyword === "pastContractCancelDate"
    )!;
    pastContractCancelDate.disabled = !flag || !!currentTransferCode;
    if (!flag) pastContractCancelDate.setDefaultValue = undefined;
    //「解除年月日」の表示切替
    pastContractCancelDate.showLine = flag;
    //引継ぎコードが設定されている場合の「解除年月日」の値設定
    if (currentTransferCode) {
      pastContractCancelDate.setDefaultValue =
        resTransf?.pastContractCancelDate;
    }
    //「特定職員数」の表示と値
    const seFlag =
      showNumberOfSpecificEmployees.includes(currentFacility?.typecode ?? "") &&
      specificStaffNumCanInputFlg === "1";
    let specifiedStaffNum = _stateTableList.find(
      (item) => item.keyword === "specifiedStaffNum"
    )!;
    specifiedStaffNum.showLine = seFlag;
    if (!seFlag) specifiedStaffNum.setDefaultValue = undefined;
    //「措置入所障害児関係業務従事職員数」の表示と値
    const dcsFlg = showNumberOfDisabledChildSaff.includes(
      currentFacility?.typecode ?? ""
    );
    let hcStaffNum = _stateTableList.find(
      (item) => item.keyword === "hcStaffNum"
    )!;
    hcStaffNum.showLine = dcsFlg;
    if (!dcsFlg) hcStaffNum.setDefaultValue = undefined;

    setStateTableList([..._stateTableList]);
    setStateSchema(flag ? { ...schema, ...dynamicSchema } : schema);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFacility, specificStaffNumCanInputFlg]);

  // 引継ぎコードによる仕様処理
  useEffect(() => {
    let _stateTableList = stateFakeTableList.current;
    const flag =
      currentFacility?.partitioncode === FacilityKbn["社会福祉施設等"];

    //「当該施設等が共済契約を締結していたことの有無」の活性/非活性
    let hadContractFlg = _stateTableList.find(
      (item) => item.keyword === "hadContractFlg"
    )!;
    hadContractFlg.disabled = !!currentTransferCode || flag;
    // 「解除年月日」の活性/非活性
    let pastContractCancelDate = _stateTableList.find(
      (item) => item.keyword === "pastContractCancelDate"
    )!;
    pastContractCancelDate.disabled = !!currentTransferCode || flag;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTransferCode]);

  const makeHttpObj = (obj: any): IAPI_FAC029_Request => {
    const reqObj: IAPI_FAC029_Request = {
      contractorNo: contractorNo,
      applyId: applyId,
      tempSaveStep: 1,
      facilityNo: resInit?.facilityNo,
      applyDate: obj.applyDate,
      facilityKbn: currentFacility?.partitioncode,
      facilityKind: currentFacility?.typecode,
      facilityName: obj.facilityName,
      zipcode: obj?.zipcode,
      prefectureCd:
        Prefectures[obj.address?.prefectures as keyof typeof Prefectures],
      city: obj.address?.city,
      addressOthers: obj.address?.address,
      applyAllowanceList: selectedAllowanceList,
      admissionCapacityNum: toNumberOrUndefined(obj.admissionCapacityNum),
      staffBaseNum: toNumberOrUndefined(obj.staffBaseNum),
      totalStaffNum: totalStaffNumRef.current,
      joinStaffNum: resInit?.joinStaffNum ?? 0,
      yearJoindisableStaffNum: obj.yearJoindisableStaffNum || null,
      timeJoindisableStaffNum: obj.timeJoindisableStaffNum || null,
      specifiedStaffNum: showNumberOfSpecificEmployees.includes(
        currentFacility?.typecode ?? ""
      )
        ? toNumberOrUndefined(obj.specifiedStaffNum)
        : undefined,
      hcStaffNum: showNumberOfDisabledChildSaff.includes(
        currentFacility?.typecode ?? ""
      )
        ? toNumberOrUndefined(obj.hcStaffNum)
        : undefined,
      salaryPaymentDelayFlg: obj.salaryPaymentDelayFlg,
      hadContractFlg:
        currentFacility?.partitioncode === FacilityKbn["社会福祉施設等"]
          ? undefined
          : obj.hadContractFlg,
      pastContractCancelDate:
        currentFacility?.partitioncode === FacilityKbn["社会福祉施設等"]
          ? resTransf?.pastContractCancelDate ?? resInit?.pastContractCancelDate
          : obj.pastContractCancelDate,
      formList:
        obj.documentaryEvidence && obj.documentaryEvidence.length > 0
          ? obj.documentaryEvidence.map((item: any, index: number) => {
              return {
                serialNo: index + 1,
                facilityNo: job_xx?.facilityNo,
                staffNo: "",
                formKbn: FormKbn["施設書類"],
                formClass:
                  formClassFacility["当該施設・事業を経営している証拠書類"],
                fileName: item.formName,
                fileBase64: item.fileBase64,
              };
            })
          : [],
      businessType: businessType,
      transferCd: currentTransferCode,
      bContractorNo: resTransf?.bContractNo,
      bFacilityNo: resTransf?.bStaffNo,
      screenId: "SCRC050101",
      checkedList: checkedList,
    };

    return reqObj;
  };

  //「登録」「続けて施設登録」の押下
  const onClickSubmit = (data: any, index: any) => {
    reqDataRef.current = data;
    buttonIndexRef.current = index;
    // エラーチェック
    if (businessState.common?.businessType === "JOB-01") {
      if (
        corpTypeSchool.includes(businessState.job_01?.businessOwnerClass) &&
        !data.transferCode
      ) {
        setState({ ...state, errorMsgId: "TKMSG_SCR0030E" });
        return;
      }
    } else if (notAllowe && !data.transferCode) {
      setState({ ...state, errorMsgId: "TKMSG_SCR0030E" });
      return;
    }
    if (dispApplyDate && !currentTransferCode) {
      setState({ ...state, errorMsgId: "TKMSG_SCR0097E" });
      return;
    }
    if (dispApplyDate && currentTransferCode !== data.transferCode) {
      setState({ ...state, errorMsgId: "TKMSG_SCR0097E" });
      return;
    }

    // 業務チェック
    if (data.salaryPaymentDelayFlg === YesOrNoFlug["有"]) {
      setState({ ...state, errorMsgId: "TKMSG_SCR0067E" });
      return;
    }
    const today = new Date();
    const nextYearDate = new Date(
      today.setFullYear(today.getFullYear() + 1)
    ).setHours(0, 0, 0, 0);
    const applyDate = new Date(data.applyDate).setHours(0, 0, 0, 0);
    if (applyDate >= nextYearDate) {
      //入出力項目.新設・申出年月日 ≧ システム日付 + 1年
      setOpenWarning(true);
      return;
    } else {
      onCheckAndSubmit(data, index);
    }
  };

  const onCheckAndSubmit = async (data: any, index: any) => {
    // 施設等新設届・申請施設更新API 呼び出し
    try {
      const res = await httpIAPI_FAC029({
        ...makeHttpObj(data),
      });
      setCheckedList(res.checkedList || []);
      if (res.resultCd === "I0000") {
        setCheckedList([]);
        switch (index) {
          case 0: // 登録
            setBusinessState({
              ...businessState,
              common: businessState.common,
              [jobName]: {
                ...job_xx,
                tempSaveStep: 1,
                applyId: applyId ?? res?.applyId,
              },
            });

            isJob_15 ? navigate("/SCRC050103") : navigate("/SCRC050102");
            break;

          case 1: // 続けて登録
            setResInit({});
            setBusinessState({
              ...businessState,
              [jobName]: {
                ...job_xx,
                tempSaveStep: 1,
                facilityNo: "",
                applyId: applyId ?? res?.applyId,
              },
            });

            //画面の入力内容をクリアする。
            let resArr = stateFakeTableList.current;
            resArr.forEach((element) => {
              if (!(element.keyword === "applyDate" && !isJob_15)) {
                element.setDefaultValue = "";
              }
              element.valueObject = { prefectures: "", city: "", address: "" };

              if (element.keyword === "facilityKbn") {
                element.text = "";
                element.isShowexplan = false;
              }

              if (
                element.keyword === "admissionCapacityNum" ||
                element.keyword === "staffBaseNum"
              ) {
                element.setDefaultValue = undefined;
              }

              if (element.keyword === "facilityKind") {
                element.setDefaultValue = undefined;
                setCurrentFacility(undefined);
              }

              if (
                element.keyword === "totalStaffNum" ||
                element.keyword === "joinStaffNum"
              ) {
                element.text = "0人";
              }

              if (element.keyword === "salaryAdjustmentAmount") {
                let selList = createSelList(
                  AllowanceType,
                  resInit?.applyAllowanceNameList
                );
                element.node = (
                  <TkSalaryAdjustmentAmount
                    open={false}
                    onConfirm={(e: any) =>
                      handleConfirm(e, resInit?.applyAllowanceNameList ?? [])
                    }
                    selList={selList}
                    selectedList={[]}
                    title="この施設で使用する手当を選択してください。"
                  />
                );
              }

              if (element.keyword === "documentaryEvidence") {
                element.setDefaultValue = [];
              }

              if (
                element.keyword === "salaryPaymentDelayFlg" ||
                element.keyword === "hadContractFlg"
              ) {
                element.disabled = false;
              }
            });
            setStateTableList([...resArr]);
            break;
        }

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onClickOk = () => {
    setOpenWarning(false);
    onCheckAndSubmit(reqDataRef.current, buttonIndexRef.current);
  };

  return (
    <Box data-testid="SCRC050101PageForTest">
      <TkStrpper steps={stepperData} activeStep={0} />

      <TkFakeTable
        list={stateTableList}
        ruleSchema={stateSchema}
        onCheckAndSubmit={onClickSubmit}
        submitButtonGroup={[
          {
            submitButtonText: "登録",
            showButton: showButton,
          },
          {
            submitButtonText: "続けて施設登録",
            showButton: showButton,
          },
        ]}
        buttonGroup={<TkBackButton />}
      />
      <TkMessageDialog
        open={openWarning}
        onOky={onClickOk}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0028W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC050101;
